import {createSelector} from 'reselect';
import props from '../../../props';

export default createSelector(
    props.vip20.bonuses.monthly_rakeback,
    props.vip20.level_preset,
    (bonus, level_preset) => {
        return {
            bonus,
            level_preset
        }
    }
)